// extracted by mini-css-extract-plugin
export var content = "_oj-1";
export var fullScreen = "_oj-0";